import React from 'react';
import logger from '../Logger';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

/**
 * Top-level safety net for render/lifecycle errors. React error boundaries do
 * NOT catch async/promise rejections — those are handled by the global
 * `unhandledrejection` listener wired up in `index.tsx`.
 */
export class ErrorBoundary extends React.Component<Props, State> {
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        logger.error('Unhandled UI error: ' + error.message, error);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: 24 }}>
                    <h2>Something went wrong.</h2>
                    <p>Please refresh the page. If the problem persists, contact support.</p>
                </div>
            );
        }
        return this.props.children;
    }
}
